/*
 * @Description:
 * @Author: HG
 * @Date: 2019-09-04 17:43:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-10-14 09:37:27
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router/";
import store from "./store/";
import axios from "axios";
import configs from "@/config/baseConfig";
import "./assets/css/common.less";
import "./utils/rem";
import models from "@/api/index";
import Storage from "vue-ls";
import { Toast, Notify } from "vant";
import headNavBar from "@/components/head-nav-bar";
import "@/permission";
import { cacheSession } from "@/utils/common";
Vue.use(headNavBar);

Vue.config.productionTip = false;
Vue.prototype.$config = configs;

// // 全局注册请求
for (const key in models) {
  if (models.hasOwnProperty(key)) {
    const item = models[key];
    Vue.prototype[key] = item;
  }
}

const storageOptions = {
  namespace: "opu_", // key prefix
  name: "ls", // name variable Vue.[ls] or this.[$ls],
  storage: "local" // storage name session, local, memory
};

Vue.use(Storage, storageOptions);
Vue.use(Toast, Notify);

axios("/config.json").then(result => {
  console.log(result.data);
  configs.fileUrl = result.data.fileUrl;
  configs.serverUrl = result.data.serverUrl;
  configs.payUrl = result.data.payUrl;
  configs.isAlertLoginMsg = result.data.isAlertLoginMsg;
  new Vue({
    router,
    store,
    created() {
      const order = cacheSession.get("order");
      store.dispatch("setOrder", order);
    },
    render: h => h(App)
  }).$mount("#app");
});
